module.exports = __webpack_public_path__ + "img/donate.a3beef9d.png";